import React from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { buildCacheKey } from '../../../util'
import { IncomeDetail } from '../../../components'
import api from '../../../api'

const IncomeDetailPage: React.FC = () => {
	const params = useParams<{ incomeID: string }>()
	const cacheKey = buildCacheKey('income', 'discrete', {
		documentID: params.incomeID,
	})

	const { data } = useSWR<Entities.Income.Object>(cacheKey, async () => {
		try {
			const response = await api.get(`/incomes/${params.incomeID}`)
			return response.data.data
		} catch (error) {
			console.error(error)
			return undefined
		}
	})

	if (!data) return <div>Cargando...</div>
	return <IncomeDetail {...data} />
}

export default IncomeDetailPage
